<div class="manage-assessment-table-container">
    <app-table  
        [data]="requestData" 
        [columns]="requestColumns" 
        [rows]="requestPageSize" 
        [selectionMode]="tableSelectionMode"
        [totalRecords]="requestTotalRecords" 
        [showPaginator]="true" 
        (lazyLoadData)="onLazyLoadEventFromTable($event)"
        [showSort]="false" 
        [showFilter]="true" 
        [loading]="requestLoading" 
        [showExportButton]="false"
        [globalFilterFields]="requestGlobalFilterFields" 
        [actions]="requestActions"
        [filterConfig]="requestFiltersConfig" 
        [(filterValue)]="requestFiltersValue" 
        (selectedRowsChange)="onSelectedItemsChange($event)"
        (searchClicked)="onRequestsSearchClicked($event)" 
        (customBtnClicked)="onToggleAction($event)" 
        (versionSelected)="onVersionSelected($event)"
        (globalSearch)="onGlobalSearch($event)" 
        [customDetailVisibilityFn]="canShowActionButtons.bind(this)"
        [deleteButtonDisabledFn]="isDeleteButtonDisabled.bind(this)"
        [reviseButtonVisibilityFn]="isReviseButtonVisible.bind(this)"
        [shareButtonDisabledFn]="isShareButtonDisabled.bind(this)"
        (filterOptionsLazyLoad)="debouncedSearch($event)">
    </app-table>
</div>

<!-- Success Popup -->
<app-manage-assessment-success-popup 
    *ngIf="successPopupVisible" 
    [visible]="successPopupVisible"
    [data]="successPopupData" 
    (closeDialog)="onSuccessPopupClose()">
</app-manage-assessment-success-popup>

<app-assessment-confirmation-popup 
    [(visible)]="showConfirmationPopup" 
    [config]="confirmationConfig"
    (confirmed)="onConfirmation($event)">
</app-assessment-confirmation-popup>

<app-assessment-share-popup 
    [(visible)]="showSharePopup" 
    [config]="sharePopupConfig"
    [assessmentData]="currentAssessmentToShare"
    (shareConfirmed)="onShareConfirmed($event)" 
    (closeDialog)="onSharePopupClose()">
</app-assessment-share-popup>

<app-assessment-due-date-extension-popup
    [(visible)]="showDueDateExtensionPopup"
    [config]="sharePopupConfig"
    (closeDialog)="onDueDateExtensionPopupClose()"
    (dueDateConfirmed)="dueDateConfirmed($event)">
</app-assessment-due-date-extension-popup>
